<template>
  <v-card class="media-display-list">
    <v-card-title>
      <v-icon left>mdi-folder-multiple-image</v-icon>
      {{ $t("PANEL.MEDIA.MEDIA_HEADER.MEDIA_LIST_TITLE") }}
      <v-btn small color="primary" class="ml-8" @click="addMedia = true">
        <v-icon left>mdi-plus</v-icon>
        {{ $t("PANEL.MEDIA.MEDIA_HEADER.ACTION_BTN") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('input', false)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-title class="d-block grey lighten-3">
      <div class="d-flex align-center">
        <div class="d-flex align-center">
          <v-card v-if="listSelection" color="transparent" elevation="0" class="mr-4">
            <v-btn-toggle v-model="listView" tile color="deep-purple accent-3" group mandatory>
              <v-btn color="primary" value="list" icon>
                <v-icon>mdi-view-list-outline</v-icon>
              </v-btn>
              <v-btn color="primary" value="grid" icon>
                <v-icon>mdi-view-grid-outline</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-card>
          <v-card v-if="format === 'files'" max-width="240" elevation="1" class="mr-4">
            <v-select max-width="300px" outlined dense :items="mediaSelectItems" hide-details color="primary" v-model="mediaFormat" :disabled="!!mediaSearch">
              <template v-slot:prepend-inner>
                <v-icon size="17" color="grey darken-4" class="mt-1">mdi-file-search-outline</v-icon>
              </template>
            </v-select>
          </v-card>
          <!-- <v-card max-width="180" elevation="1" class="mr-4">
        <v-select
          max-width="300px"
          outlined
          dense
          :items="dateSelectItems"
          hide-details
          color="primary"
          v-model="mediaTime"
        >
          <template v-slot:prepend-inner>
            <v-icon size="17" color="grey darken-4" class="mt-1">mdi-calendar-range</v-icon>
          </template>
        </v-select>
          </v-card>-->
          <div v-show="multiple">
            <v-card v-if="!multipleSelect" elevation="0" color="transparent">
              <v-btn color="primary" text class="text-capitalize grey lighten-2" depressed @click="multipleToggle">
                <v-icon left>mdi-checkbox-multiple-marked-outline</v-icon>
                {{ $t("PANEL.MEDIA.MEDIA_SUB_HEADER.MEDIA_LIST_MASS_SELECTING") }}
              </v-btn>
            </v-card>
            <v-card v-else elevation="0" color="transparent">
              <v-chip color="primary" label class="mr-3"
                >{{
                  selectedFiles.length > 0
                    ? $t("PANEL.MEDIA.MEDIA_SUB_HEADER.SELECTED_FILE_COUNT", { COUNT: selectedFiles.length })
                    : $t("PANEL.MEDIA.MEDIA_SUB_HEADER.NOT_SELECT")
                }}
              </v-chip>
              <v-btn color="red" text class="text-capitalize grey lighten-2 mr-3" depressed @click="multipleToggle">
                <v-icon left>mdi-checkbox-multiple-marked-outline</v-icon>
                {{ $t("PANEL.MEDIA.MEDIA_SUB_HEADER.CANCEL") }}
              </v-btn>
              <v-btn
                color="red"
                class="text-capitalize"
                :class="selectedFiles.length == 0 ? 'grey lighten-2' : ''"
                :text="selectedFiles.length == 0"
                :dark="selectedFiles.length != 0"
                depressed
                :disabled="selectedFiles.length == 0"
                @click="removeFiles(selectedFiles.map(file => file.name))"
              >
                <v-icon left>mdi-trash-can-outline</v-icon>
                {{ $t("PANEL.MEDIA.MEDIA_SUB_HEADER.PERMANENTLY_DELETE") }}
              </v-btn>
            </v-card>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex align-center">
          <v-text-field
            solo
            dense
            hide-details
            :label="$t('PANEL.MEDIA.MEDIA_SUB_HEADER.SEARCH_LABEL')"
            prepend-inner-icon="mdi-magnify"
            clearable
            @keyup.enter="searchMedia"
            v-model="mediaSearch"
          ></v-text-field>
        </div>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text :id="randomId" class="grey lighten-3" style="height:500px;">
      <div id="mediaListFiles">
        <v-container fluid>
          <div v-show="!noMediaItems" v-if="mediaList.length > 0">
            <v-row v-if="listView == 'grid'">
              <v-col
                cols="12"
                sm="4"
                md="3"
                lg="2"
                xl="2"
                :key="key"
                v-for="(file, key) in mediaList"
                @click="selectFile(file)"
                :class="{ 'wobble-hor-bottom': multipleSelect }"
              >
                <v-hover v-slot="{ hover }">
                  <div class="media-item d-flex justify-center align-center rounded-lg overflow-hidden white elevation-2" v-ripple>
                    <div class="media-item-context">
                      <file-thumbnailer :value="file" :viewport-height="thumbHeight()" padding="0 0 0 0" />
                    </div>
                    <div v-show="!isBaseImage(file.type)" class="media-item-text">{{ file.name }}</div>
                    <span v-show="isSelected(file)" class="media-item-border">
                      <span class="media-item-border-icon">
                        <v-icon class="ml-3 mt-3" size="35" dark>mdi-check</v-icon>
                      </span>
                    </span>
                    <span v-show="hover" class="media-item-edit px-2 py-2">
                      <v-btn ref="fileDialogBtn" color="blue" fab small dark @click="selectedFileDialog(file, $event)">
                        <v-icon>mdi-pen</v-icon>
                      </v-btn>
                    </span>
                  </div>
                </v-hover>
              </v-col>
            </v-row>
            <v-row v-else-if="listView == 'list'">
              <v-col cols="12" :key="key" v-for="(file, key) in mediaList" :class="{ 'wobble-hor-bottom': multipleSelect }">
                <v-container class="rounded-lg overflow-hidden white elevation-2">
                  <v-row>
                    <v-col cols="12" md="3" class="py-0">
                      <div class="media-item-context">
                        <file-thumbnailer :value="file" viewport-height="160" padding="0 0 0 0" class="overflow-hidden rounded-lg" />
                      </div>
                    </v-col>
                    <v-col cols="12" md="7">
                      <div class="mb-2">
                        <div>
                          <b>{{ $t("PANEL.MEDIA.LIST_VIEW.FILE_NAME") }}:</b>
                        </div>
                        <div class="grey--text text--darken-3">{{ file.name }}</div>
                      </div>
                      <div class="mb-2">
                        <div>
                          <b>{{ $t("PANEL.MEDIA.LIST_VIEW.SIZE") }}:</b>
                        </div>
                        <div>{{ file.size }}</div>
                      </div>
                      <div>
                        <v-btn small color="blue" dark @click="selectFile(file)">
                          <v-icon left>mdi-file-find</v-icon>
                          {{ $t("PANEL.MEDIA.LIST_VIEW.DETAILS") }}
                        </v-btn>
                      </div>
                    </v-col>
                    <v-col cols="12" md="2">
                      <div>
                        <b>{{ $t("PANEL.MEDIA.LIST_VIEW.UPLOADED_DATE") }}:</b>
                      </div>
                      <div class="d-flex align-center text-subtitle-2">
                        <v-icon size="18" class="mr-1">mdi-calendar-range</v-icon>
                        {{ fileDate(file.time) }}
                      </div>
                      <div class="d-flex align-center text-subtitle-2">
                        <v-icon size="18" class="mr-1">mdi-clock-outline</v-icon>
                        {{ fileTime(file.time) }}
                      </div>
                    </v-col>
                  </v-row>
                  <span v-show="isSelected(file)" class="media-item-border">
                    <span class="media-item-border-icon">
                      <v-icon class="ml-3 mt-3" size="35" dark>mdi-check</v-icon>
                    </span>
                  </span>
                </v-container>
              </v-col>
            </v-row>
          </div>

          <div v-show="!noMediaItems" v-else>
            <v-row v-if="listView == 'grid'">
              <v-col cols="12" sm="4" md="3" lg="2" xl="3" :key="n" v-for="n in x">
                <v-skeleton-loader class="mx-auto" :height="thumbHeight()" type="card"></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row v-else-if="listView == 'list'">
              <v-col cols="12" :key="n" v-for="n in x">
                <v-skeleton-loader class="mx-auto" height="160" type="card"></v-skeleton-loader>
              </v-col>
            </v-row>
          </div>

          <v-row v-if="mediaListPagination.loading">
            <v-col class="mx-auto mt-2" cols="12" lg="3">
              <div class="text-center">{{ $t("PANEL.MEDIA.LIST.LOADING_FILES") }}</div>
              <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>

          <v-row v-if="noMediaItems">
            <v-col cols="12">
              <p class="text-h5 grey--text text-center mt-10">
                <b>{{ $t("PANEL.MEDIA.LIST.NO_MEDIA_CONTENT") }}</b>
              </p>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-chip
        v-show="selectedFiles.length > 0 && multiple"
        color="blue"
        dark
        label
        class="mr-2"
        v-html="$t('PANEL.MEDIA.DISPLAY_LIST.SELECTED_FILES', { COUNT: `<b class='mr-1'>${selectedFiles.length}</b>` })"
      >
      </v-chip>
      <v-btn color="blue" dark class="text-capitalize px-5" @click="mediaListSuccess">
        {{ $t("PANEL.MEDIA.DISPLAY_LIST.OK_BTN") }}
      </v-btn>
    </v-card-actions>
    <file-viewer v-model="fileInfoSelect" @deleted="removedFiles" @change="changedMediaListSingle" />
    <add-media v-model="addMedia" @added="mediaSelectsChanged" />
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import FileThumbnailer from "./FileThumbnailer.vue";
import FileViewer from "./FileViewer.vue";
import MediaService from "@/services/MediaService";
import AddMedia from "./AddMedia.vue";

export default {
  components: { FileThumbnailer, FileViewer, AddMedia },
  name: "MediaDisplayList",
  props: {
    update: {
      default: false,
      required: false
    },
    list: {
      default: "grid"
    },
    listSelection: {
      default: true
    },
    /**
     * Seçim yapılacak türü belirtir
     */
    format: {
      default: "files"
    },
    /**
     * mode: default,
     * mode: selecting
     *
     * İşlemlerine göre resim seçme ve seçmeme eylemi
     */
    mode: {
      default: "default"
    },
    /**
     * Seçim çoklu mu yoksa tekli mi olacak
     */
    multiple: {
      default: false
    },
    /**
     * Selected event tetiklendikten sonra seçimi tekrar sıfırlar
     */
    closeSelection: {
      default: false
    }
  },
  data: vm => ({
    addMedia: false,
    listView: vm.list,
    x: 12,
    listType: "list",
    mediaSelectItems: [],
    dateSelectItems: [],
    selectedFiles: [],
    multipleSelect: false,
    fileInfoSelect: {},
    mediaFormat: vm.format,
    mediaTime: "",
    mediaSearch: "",
    noMediaItems: false,
    mediaListPagination: {
      start: 0,
      limit: 48,
      loading: false,
      mediaExist: true
    },
    mediaDisplayHeight: 0,
    randomId: `displayMediaListInner-${Math.floor(Math.random() * 5000 + 1) + "-" + Math.floor(Math.random() * 5000 + 1)}`
  }),
  computed: {
    ...mapState({
      mediaList: state => state.Media.MediaList.mediaList,
      acceptFilesList: state => state.Media.acceptFilesList,
      mediaListTypes: state => state.Media.mediaListTypes,
      mediaFormats: state => state.Media.mediaFormats
    }),
    ...mapGetters({
      isBaseImage: "Media/isBaseImage"
    })
  },
  methods: {
    thumbHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 250;
        case "sm":
          return 160;
        case "md":
          return 160;
        case "lg":
          return 160;
        case "xl":
          return 200;
      }
    },
    mediaListSuccess() {
      this.$emit("selected", this.multiple ? this.selectedFiles : this.selectedFiles[0]);
      if (this.closeSelection) {
        this.selectedFiles = [];
      }
      this.$emit("input", false);
    },
    selectFile(file) {
      if (this.multiple) {
        this.selectedFile(file);
      } else {
        this.selectedFileSingle(file);
      }
    },
    isSelected(file) {
      return this.selectedFiles.includes(file);
    },
    selectedFile(file) {
      let selectedFiles = this.selectedFiles;
      if (!selectedFiles.includes(file)) {
        selectedFiles.push(file);
      } else {
        selectedFiles.splice(selectedFiles.indexOf(file), 1);
      }
    },
    selectedFileSingle(file) {
      this.selectedFiles = [];
      this.selectedFiles.push(file);
      this.mediaListSuccess();
    },
    selectedFileDialog(file, e) {
      e.stopPropagation();
      this.fileInfoSelect = file;
    },
    multipleToggle() {
      this.selectedFiles = [];
      if (!this.multipleSelect) {
        this.multipleSelect = true;
      } else {
        this.multipleSelect = false;
      }
    },
    mediaSelectsChanged() {
      const { mediaFormat, mediaTime } = this;
      Promise.resolve(this.resetMediaListLimit()).then(() => {
        this.$store
          .dispatch("Media/MediaList/getMediaList", {
            mediaFormat,
            mediaTime
          })
          .then(result => this.noItemsDetect(result.data));
      });
    },
    mediaListLimit() {
      if (this.mediaListPagination.mediaExist && !this.mediaListPagination.loading) {
        this.setMediaListLimit();
        const { mediaFormat, mediaTime } = this,
          { start, limit } = this.mediaListPagination;
        this.mediaListPagination.loading = true;
        this.$store
          .dispatch("Media/MediaList/getMediaListLimit", {
            mediaFormat,
            mediaTime,
            start,
            limit
          })
          .then(res => {
            if (res.data.length == 0) {
              this.mediaListPagination.mediaExist = false;
            }
            this.mediaListPagination.loading = false;
          });
      }
    },
    setMediaListLimit() {
      this.mediaListPagination.start += Number(this.mediaListPagination.limit);
      return this.mediaListPagination;
    },
    resetMediaListLimit() {
      this.mediaListPagination.start = 0;
      this.mediaListPagination.mediaExist = true;
      return this.mediaListPagination;
    },
    removeFiles(filesList) {
      MediaService.removeFiles(filesList).then(res => {
        if (res.status === 200) {
          this.removedFiles(filesList);
          this.multipleToggle();
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    removedFiles(fileNames) {
      this.selectedFiles = [];
      fileNames = fileNames.constructor === Array ? fileNames : [fileNames];
      let mediaList = this.mediaList.filter(media => {
        return !fileNames.includes(media.name);
      });
      this.noItemsDetect(mediaList);
      this.$store.commit("Media/MediaList/setMediaList", mediaList);
    },
    searchMedia() {
      this.$store
        .dispatch("Media/MediaList/searchMedia", {
          search: this.mediaSearch
        })
        .then(result => this.noItemsDetect(result.data));
    },
    changedMediaListSingle(file) {
      return new Promise((resolve, reject) => {
        let search = file.name.replace(".", " ").split(" ")[0];
        this.selectedFiles = [];
        MediaService.searchMedia({ search })
          .then(res => {
            let newFile = res.data[0];
            if (res.status === 200) {
              let mediaList = this.mediaList.filter(media => {
                return media.name !== newFile.name;
              });
              mediaList.unshift(newFile);
              this.$store.commit("Media/MediaList/setMediaList", mediaList);
            }
            resolve(res.data[0]);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    noItemsDetect(items) {
      if (items.length == 0) {
        this.noMediaItems = true;
      } else {
        this.noMediaItems = false;
      }
    },
    fileDate(date) {
      let newDate = date.split("-");
      return newDate[0];
    },
    fileTime(date) {
      let newTime = date.split("-");
      return newTime[1];
    }
  },
  created() {
    let self = this;

    /**
     * Medya listesi formatlarını getir
     */
    self.$store.dispatch("Media/getMediaFormats").then(() => {
      let formats = self.mediaFormats,
        formatItems = [];
      for (let format in formats) {
        formatItems.push({
          text: format,
          value: formats[format]
        });
      }
      this.mediaSelectItems = formatItems;
      this.mediaFormat = this.format;
    });

    /**
     * Media tarih sorgusu için tarihleri ayarla
     */
    let selectDates;

    let treeMonths = new Date(Date.now());
    treeMonths.setMonth(treeMonths.getMonth() - 3);
    let sixMonths = new Date(Date.now());
    sixMonths.setMonth(sixMonths.getMonth() - 6);
    let oneYear = new Date(Date.now());
    oneYear.setMonth(oneYear.getMonth() - 12);

    selectDates = [
      {
        text: this.$t("PANEL.MEDIA.DATE_SELECTION.ALL_DATES"),
        value: ""
      },
      {
        text: this.$t("PANEL.MEDIA.DATE_SELECTION.THREE_MONTHS_AGO"),
        value: ["-4 month", "-3 month"]
      },
      {
        text: this.$t("PANEL.MEDIA.DATE_SELECTION.SIX_MONTHS_AGO"),
        value: ["-9 month", "-6 month"]
      },
      {
        text: this.$t("PANEL.MEDIA.DATE_SELECTION.LAST_YEAR"),
        value: [12, 12]
      }
    ];

    this.dateSelectItems = selectDates;
    this.mediaTime = selectDates[0].value;
  },
  mounted() {
    /**
     * Media List Offset Y
     */
    document.getElementById(this.randomId).addEventListener("scroll", e => {
      if (this.mediaListPagination.limit >= this.mediaList) {
        let scrollArea = e.target.scrollHeight - e.target.offsetHeight;
        if (scrollArea < e.target.scrollTop + 20) {
          this.mediaListLimit();
        }
      }
    });
  },
  watch: {
    mediaFormat: {
      handler(value) {
        if (value !== "undefined") {
          this.mediaSelectsChanged();
        }
      },
      immediate: true
    },
    mediaTime() {
      this.mediaSelectsChanged();
    },
    update() {
      this.mediaSelectsChanged();
    },
    mediaSearch() {
      this.mediaSearch = this.mediaSearch ?? "";

      if (!this.mediaSearch) {
        this.mediaSelectsChanged();
      } else {
        if (this.mediaFormat != this.mediaSelectItems[0].value) {
          this.mediaFormat = this.mediaSelectItems[0].value;
        }
      }
    }
  }
};
</script>

<style>
/* .media-display-list {
  height: 100%;
}
#mediaListFiles {
  overflow-y: auto;
}
#mediaListFiles > div,
#mediaListFiles > div > div,
#mediaListFiles > div > div > div {
  height: 100%;
}
.media-display-list {
  overflow: hidden;
} */
.media-item {
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: relative;
}

.media-item-context {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: absolute;
  width: 100%;
  font-size: 14px;
  padding: 0 1em;
  overflow: hidden;
  text-overflow: ellipsis;
  text-overflow: clip ellipsis clip 0 3ch;
  direction: rtl;
  white-space: nowrap; */
}

.media-item-border {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.411);
  border-radius: 10px;
}

.media-item-edit {
  position: absolute;
  bottom: 0;
  right: 0;
}

.media-item img {
  max-width: 100%;
}

.media-item-text {
  width: 100%;
  word-break: break-all;
  position: absolute;
  bottom: 0;
  padding: 0.5em;
  background: #ffffffa8;
  line-height: 1.5;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  text-overflow: clip ellipsis clip 0 3ch;
  direction: rtl;
  white-space: nowrap;
  -webkit-line-clamp: 3;
  text-align: center;
}

.wobble-hor-bottom {
  -webkit-animation: wobble-hor-bottom 0.65s both;
  animation: wobble-hor-bottom 0.65s both;
}

@-webkit-keyframes wobble-hor-bottom {
  0%,
  100% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: translateX(-30px) rotate(-6deg);
    transform: translateX(-30px) rotate(-6deg);
  }
  30% {
    -webkit-transform: translateX(15px) rotate(6deg);
    transform: translateX(15px) rotate(6deg);
  }
  45% {
    -webkit-transform: translateX(-15px) rotate(-3.6deg);
    transform: translateX(-15px) rotate(-3.6deg);
  }
  60% {
    -webkit-transform: translateX(9px) rotate(2.4deg);
    transform: translateX(9px) rotate(2.4deg);
  }
  75% {
    -webkit-transform: translateX(-6px) rotate(-1.2deg);
    transform: translateX(-6px) rotate(-1.2deg);
  }
}

@keyframes wobble-hor-bottom {
  0%,
  100% {
    -webkit-transform: translateX(0%);
    transform: translateX(0%);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
  }
  15% {
    -webkit-transform: translateX(-30px) rotate(-6deg);
    transform: translateX(-30px) rotate(-6deg);
  }
  30% {
    -webkit-transform: translateX(15px) rotate(6deg);
    transform: translateX(15px) rotate(6deg);
  }
  45% {
    -webkit-transform: translateX(-15px) rotate(-3.6deg);
    transform: translateX(-15px) rotate(-3.6deg);
  }
  60% {
    -webkit-transform: translateX(9px) rotate(2.4deg);
    transform: translateX(9px) rotate(2.4deg);
  }
  75% {
    -webkit-transform: translateX(-6px) rotate(-1.2deg);
    transform: translateX(-6px) rotate(-1.2deg);
  }
}
</style>
